import { render, staticRenderFns } from "./PhieuCoc.vue?vue&type=template&id=407328b5&scoped=true"
import script from "./PhieuCoc.vue?vue&type=script&lang=js"
export * from "./PhieuCoc.vue?vue&type=script&lang=js"
import style0 from "./PhieuCoc.vue?vue&type=style&index=0&id=407328b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407328b5",
  null
  
)

export default component.exports